<template>
    <div class="ve-list-page ve-list-page--embedded">
        <section v-loading="loading"></section>  
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;padding-top:3px; border-bottom:2px solid #389;">   
            <div style="width:1300px;display:flex; ">
            <div style="font-size:12px;line-height:30px;margin-right:4px">字段</div>
            <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:120px;margin-left:2px; ">
                <span v-for="item in payCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select> 
            <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:300px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:90px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small"  slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
            <el-select v-model="selparam2"  placeholder="请选择列名" clearable size="small" style="width:120px; ">
                <span v-for="item in payCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-input :placeholder="input_hold" v-model="txtparam2" @keyup.enter.native="qryTabData" size="small" style="width:300px; height:30px; ">
                <el-select v-model="oper2" slot="prepend"   style="width:90px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
            <span style="color:#389;margin-left:10px;margin-right:5px;font-size:12px">状态</span>
            <el-select v-model="stfg_"  size="small" @change="stfgChange" style="width:130px;margin-bottom:3px;margin-left:2px; ">
                <el-option label="所有订单" value="ALL" ></el-option>
                <el-option label="已对账未收票" value="Y" ></el-option> 
                <el-option label="已对账已收票" value="OK" ></el-option> 
                <el-option label="未对账" value="N" ></el-option> 
            </el-select> 
             <el-button type="primary"   icon="iconfont icon-daochu" @click="expExcel" size="mini" style="margin-left:15px;height:30px;margin-top:1px">导出当前页面</el-button>
            </div>
        </div> 
        <el-table  :data="tabData" 
                border                            
                disabled-hover
                class="custom-table-border ve-list-page__table"
                :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                style="overflow:auto;margin-top:1px;"
                size="small"
                height="100%"
                :row-key="getRowKey"  
                ref="tabref" 
   
                v-loading="v_loading"
                element-loading-text="数据加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(100, 100, 100, 0.8)"
                highlight-current-row>
                <el-table-column label="序号" width="70" type="index"></el-table-column>
                <el-table-column  v-for="(item,index ) in payCol.filter(item=>item.thide=='N'&&item.key!=='SEL')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.notnull=='Y'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repShow(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-link v-else-if="item.key=='FINVNO'" :underline="false" @click="repShow2(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-checkbox disabled v-else-if="item.edcss=='checkbox'" v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                        <el-link v-else-if="item.key=='FILEPATH'" :underline="false" > 
                            <div v-if="scope.row[item.key] && scope.row[item.key].lastIndexOf('.pdf')>-1 ">
                                <div @click="imgPreview(scope.row[item.key])" slot="error"><i class="iconfont icon-pdf"></i></div>
                            </div>
                            <el-image v-else style="width:100%;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        </el-link>
                        <div v-else v-text="scope.row[item.key]" style="float:left"> </div>
                    </template>
                </el-table-column>  
                 
        </el-table>  
        <!-- 分页查询 -->
        <div class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
 
            </div>
        </div>
   
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="showViewer" width="1200px" append-to-body top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
            </div>
            <div style="height:80vh;overflow-y:auto">
                <el-image fit="scale-down"  style=" margin:5px auto;height:800px;width:100% " :src="listurl"></el-image>
            </div>
        </el-dialog>
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate } from '../../api/Select' 
//局部注册
export default {
    name:"po_queryList_item",
    data () {
        return {
            repWin:false,
            repUrl:'',
            loadWin:false,
            payCol:[],
       
            dtlRow:{},
            operFlag:false,
            saveFlag:true,
            listurl:'',
            promptWin:false,
            prompt:'',
            showViewer:false,
            mainRow:{},
            input_hold:'请输入查询的值',
         
            listIndex:'-1',
            active:'', //二级菜单选中标志
            stfg_:'Y',
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            dtlData:[], //明细数据
     
            operArr:[],
            oper:'like',
            oper2:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            txtparam2:'',
            selparam2:'',
            delArr:[],
 
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
            rowSize:100,
            goPage:'',
            notNull:[],
            current:1,
            loading:false,
            v_loading:false,
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            stfgArr:[],
            pageList: [ {
                value: 100,
                label: '100'
                }, {
                value: 300,
                label: '300'
            }],
            v_index:'',   
            v_idseq:'',  
        }
    },
    mounted () { 
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','16083','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','16083','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
 
    },
    computed: {
 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
    },
    components: {
 
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.qryTabData()
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if( column.property==='AMT'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        //图片预览
        imgPreview(path){
            this.showViewer=true
            this.listurl=path
        },
        repShow(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+ 'fin_stkchk.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
        },
        repShow2(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+ 'inv_stkchk.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] +'&p_invno='+row['FINVNO'] 
        },
        //导出
        expExcel(){
            this.loadWin =true   
            //导出
            this.$axios({
                method: 'post',
                url:'xuper_auth/report/GenExcel',
                data: {p_idseq:'397193',p_lstseq:'2064',p_json:JSON.stringify(this.allData),p_action:'采购对账明细'},
                responseType:'blob' //关键，声明响应类型为二进制流
            }).then(response=>{ 
                // 从响应头解析后端设置的文件名
                // 创建Blob对象并触发下载  创建下载链接
                const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob)
                link.download = '采购对账明细_'+getDate('full')+'.xls'
                link.click()
                URL.revokeObjectURL(link.href)
                this.loadWin =false
            }) 
 
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },
 
        //订单明细
        getOrdList(cond){
            let v_cond = ''
            // if (this.v_admin=='N' ){
            //     v_cond = ' and supno in (select idno from V_bs_sup where PHONENO=\''+this.v_username+'\')'
            // }
            this.v_loading =true
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid',p_value:this.v_corpid,p_key2:'idty',p_value2:'POIN', p_cond:v_cond +cond+ ' order by '+this.selparam+' desc',p_table:'V_STKDTL'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.tabref.doLayout()
                    })
                    this.v_loading =false
                    if (this.allData.length>0){
                        this.$refs.tabref.setCurrentRow(this.allData[0])
                    }
                    this.initPage()
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                    this.v_loading =false
                }
                
            }) 
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素            
            } 
        },
 
        getDtlKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
 
        getRowKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                }
            }
           
            if (this.stfg_=='ALL'){
                this.getOrdList( cond_)
            }else {
                if (this.stfg_=='Y'){
                    this.getOrdList( ' and fchk=\''+this.stfg_+'\''+ cond_+' and rcvdttm is null')
                }if (this.stfg_=='OK'){
                    this.getOrdList( ' and fchk=\'Y\'' + cond_+' and rcvdttm is not null')
                }else{
                    this.getOrdList( ' and fchk=\''+this.stfg_+'\''+ cond_ )
                }
            }
        },
 
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397193','lstseq','2065','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.payCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 98%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .item-one{
        width: 96%;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
